import React, { useReducer, useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  Button,
  ColumnLayout,
  FormField,
  Input,
  Select,
  Textarea,
  Icon,
  Spinner,
  Flash
} from "AWS-UI-Components-React";

import {
  asyncCreateTestCase,
  clearTestCaseStatusUpdated
} from "../actions/testCaseActions.js";

import "../styles/test-case-form.css";

const TestCaseForm = (props) => {

  const {
    testCaseFromProps,
    testCaseState,
    featureState,
    userStoryState,
    tagState,
    fetchTags,
    createTag
  } = props;

  const [id, setId] = useState(null);
  const [tagList, setTagList] = useState([]);
  const [selectedTag, setSelectedTag] = useState(null);
  const [createdTest, setCreatedTest] = useState(null);
  const [userStoryInvalid, setUserStoryInvalid] = useState(false);
  const [featureInvalid, setFeatureInvalid] = useState(false);
  const [inputValues, setInputValues] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      testSuite: null,
      testName: null,
      testBody: null
    }
  );
  const [selectValues, setSelectValues] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      dummy: null,
    }
  );

//   useEffect(() => {
//     if (!featureState.finishedLoadingUserStoriesAndFeatures) {
//       props.fetchFeaturesAndUserStories();
//       props.fetchTags();
//     }
//     if (testCaseFromProps) {
//       setId(testCaseFromProps.id);
//       setInputValues({
//         technicalOwner: testCaseFromProps.technicalOwner,
//         productOwner: testCaseFromProps.productOwner,
//         version: testCaseFromProps.version,
//         priority: testCaseFromProps.priority,
//         setup: testCaseFromProps.setup,
//         execution: testCaseFromProps.execution,
//         validation: testCaseFromProps.validation,
//         expectedResult: testCaseFromProps.expectedResult,
//         userStory: testCaseFromProps.userStory,
//         feature: testCaseFromProps.feature,
//         id: testCaseFromProps.id
//       });
//       setSelectValues({
//         priority: testCaseFromProps.priority,
//         readinessState: testCaseFromProps.readinessState,
//         automationState: testCaseFromProps.automationState
//       });
//       if (testCaseFromProps.tags) {
//         setTagList(testCaseFromProps.tags);
//       }
//     }
//   }, []);

  const handleInputChange = (e) => {
      const { name, value } = e.target.component;
      setInputValues({ [name]: value !== "" ? value : null });
  };

  const handleJSONInputChange = (e) => {
    const { name, value } = e.target.component;
    console.log(JSON.stringify(JSON.parse(value)));
    setInputValues({ [name]: value !== "" ? JSON.stringify(JSON.parse(value)) : null });
};

  const handleClearInputs = () => {
    setInputValues({
        testSuite: null,
        testName: null,
        testBody:null
      });
  };

  const handleSubmitTestCase = async () => {
    const request = {
      ...inputValues,
      ...selectValues
    };
    const response = await props.createTestCase(request);
    if (response && response.payload && response.payload.id) {
      setCreatedTest(response.payload);
    }
  };

  const handleUpdateTestCase = () => {
    const request = {
      id,
      ...inputValues,
      ...selectValues,
      tags: tagList
    };
    props.updateHandler(request);
  };

  const ButtonActionStripe = (
    <div className="awsui-util-action-stripe-group awsui-util-f-r">
      <Button
        text="Clear"
        onClick={handleClearInputs}
        variant="normal"
        disabled={!inputValues.testSuite || !inputValues.testName}
      />
      <Button
        text="Create Test Case"
        variant="primary"
        onClick={handleSubmitTestCase}
        disabled={!inputValues.testSuite || !inputValues.testName}
        loading={testCaseState.saveTestCaseLoading}
      />
    </div>
  );

  const UpdateButtonActionStripe = (
    <div className="awsui-util-action-stripe-group awsui-util-f-r">
      <Button
        text="Cancel"
        variant="normal"
        onClick={() => props.editHandler()}
      />
      <Button
        text="Update Test Case"
        variant="primary"
        onClick={handleUpdateTestCase}
        disabled={!inputValues.technicalOwner || featureInvalid || userStoryInvalid}
      />
    </div>
  );

  const RedirectContent = () => {
    return (
      createdTest &&
      <Redirect
        to={{
          pathname: `/test-cases/${createdTest.id}`,
          state: { testCase: createdTest, created: true }
        }}
      />
    );
  };

  const suiteLabel = window.location.pathname === "/create-test-case" ? "Suite" : "Suite";
  const nameLabel = window.location.pathname === "/create-test-case" ? "Name" : "Name";

  // const FlashMessage = () => {
  //   const successHeaderMessage =  "Test case created successfully!" ;
  //   const unsuccessfulHeaderMessage = "Something went wrong";

  //   return (
  //     <div>
  //       {testCaseState.createdOrUpdatedTestCase &&
  //         <Flash
  //           header={testCaseState.createdOrUpdatedTestCase
  //             ? successHeaderMessage
  //             : unsuccessfulHeaderMessage}
  //           type={testCaseState.createdOrUpdatedTestCase ? "success" : "error"}
  //           dismissible={true}
  //           onDismiss={() => props.clearTestCaseStatusUpdated()}
  //         ></Flash>}
  //     </div>
  //   );
  // };

  const FormContent = (
    <div className="awsui">
      {/* <FlashMessage /> */}
      <ColumnLayout columns={2} variant="text-grid">
        <div data-awsui-column-layout-root="true">
          <div>
            <FormField
              label={suiteLabel}
              description="Test Suite"
            >
                <Input
                    type="text"
                    name="testSuite"
                    placeholder="Enter suite"
                    value={inputValues.testSuite}
                    onInput={handleInputChange}
              />
            </FormField>
          </div>
          <div>
            <FormField
              label={nameLabel}
              description="Test Name"
            >
                <Input
                    type="text"
                    name="testName"
                    placeholder="Enter name"
                    value={inputValues.testName}
                    onInput={handleInputChange}
              />
            </FormField>
          </div>
        </div>
      </ColumnLayout>
      <ColumnLayout columns={1} variant="text-grid">
        <div data-awsui-column-layout-root="true">
          <div>
            <FormField
              label="CEV Test"
              description="CEV Test"
            >
                <Textarea
                    type="text"
                    name="testBody"
                    placeholder="Enter CEV Test JSON"
                    value={inputValues.testBody}
                    onInput={handleJSONInputChange}
              />
            </FormField>
          </div>
        </div>
      </ColumnLayout>

      <div>
        <br />
        <ColumnLayout columns={2} variant="text-grid">
          <div data-awsui-column-layout-root="true">
            <div>
            </div>
            <div>
              {!testCaseFromProps ? ButtonActionStripe : UpdateButtonActionStripe}
            </div>
          </div>
        </ColumnLayout>
      </div>
    </div>
  );

  return (
    <div>
      {FormContent}
      <RedirectContent />
    </div>
  );
};

const mapStateToProps = state => ({
  testCaseState: state.testCaseState,
});

const mapDispatchToProps = dispatch => ({
  createTestCase: (request) => dispatch(asyncCreateTestCase(request)),
  clearTestCaseStatusUpdated: () => dispatch(clearTestCaseStatusUpdated())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TestCaseForm);


// WEBPACK FOOTER //
// ./src/components/TestCaseForm.jsx